// Core imports
import * as React from 'react';
import * as moment from 'moment';

// Components imports
import DateRangePicker from 'react-daterange-picker';

// Models imports

// Style and misc imports
import './DateSingle.scss';
import { ButtonBase } from '@material-ui/core';

class DateSingle extends React.Component<IDateSingleProps, IDateSingleState> {
  private calendarRef: any = null;
  constructor(props: IDateSingleProps) {
    super(props);

    this.state = {
      calendarIsOpen: false,
      date: null,
      dateText: 'MM/DD/YYYY'
    };
  }

  /* 
    saveDate : Saves date range value using props actions
   */
  private saveDate = () => {
    const { date } = this.state;
    this.props.onDateSelected(date);
  };

  /* 
    openCalendar
   */
  private openCalendar = () => {
    this.setState({ calendarIsOpen: true });
  };

  /* 
    closeCalendar
   */
  private closeCalendar = () => {
    this.setState({ calendarIsOpen: false });
  };

  /* 
    handleShowStartCalendar : 
   */
  private handleShowCalendar = () => {
    this.state.calendarIsOpen ? this.closeCalendar() : this.openCalendar();
  };

  /* 
    setStartDate
   */
  private setDate = (date: moment.Moment) => {
    this.setState({ date }, () => {
      this.saveDate();
    });
    this.closeCalendar();
    const headerText = !this.state.date
      ? 'MM/DD/YYYY'
      : `${this.state.date.format('MM/DD/YYYY')}`;
    this.setState({ dateText: headerText });
  };
  public componentDidUpdate = (prevProps: IDateSingleProps) => {
    if (this.props.date !== prevProps.date) {
      const headerText = !this.props.date
        ? 'MM/DD/YYYY'
        : `${this.props.date.format('MM/DD/YYYY')}`;
      this.setState({ dateText: headerText });
    }
  };

  public componentDidMount = () => {
    if (this.props.date !== null) {
      this.setState({
        date: this.props.date,
        dateText: `${this.props.date.format('MM/DD/YYYY')}`
      });
    } else {
      this.setState({
        date: null,
        dateText: 'MM/DD/YYYY'
      });
    }
  };

  private handleClickOutside = (e: any) => {
    if (this.calendarRef == null || this.calendarRef.contains == null) {
      return;
    }
    if (this.calendarRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      calendarIsOpen: false
    });
  };

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  public render() {
    const { t } = this.props;

    const calendarStatus = this.state.calendarIsOpen ? 'opened' : 'closed';

    return (
      <div className="rp-date-single">
        <div className="rp-date-single--header">
          <div className="rp-date-single--header---container">
            <div
              className="date-single--date-picker-start"
              onClick={this.handleShowCalendar}
            >
              <span
                className={`${
                  !this.state.date || !this.props.date ? 'disabled' : 'enabled'
                }`}
              >
                {this.state.dateText}
              </span>
              <i
                className="rpds-calendar-today"
                onKeyDown={this.handleShowCalendar}
                tabIndex={0}
              />
            </div>
          </div>
        </div>
        <div
          className={`calendar-start-container ${calendarStatus}`}
          ref={(ref: any) => (this.calendarRef = ref)}
          onKeyDown={this.handleShowCalendar}
        >
          {this.state.calendarIsOpen ? (
            <DateRangePicker
              className="rp-date-single--start-calendar"
              onSelect={this.setDate}
              value={this.props.date === null ? null : this.state.date}
              selectionType="single"
              numberOfCalendars={1}
              maximumDate={this.props.maxdate ? this.props.maxdate : null}
              minimumDate={
                this.props.installdate ? this.props.installdate.toDate() : null
              }
            />
          ) : (
            <React.Fragment />
          )}
        </div>
      </div>
    );
  }
}

export default DateSingle;

interface IDateSingleProps {
  onDateSelected(date: any): void;
  t: any;
  date: moment.Moment | null;
  maxdate?: any;
  installdate?: any;
  reset?: any;
}

interface IDateSingleState {
  calendarIsOpen: boolean;
  date: moment.Moment | null;
  dateText: string;
}
